const styles = {
    ticket: {
        aspectRatio: "1 / 1",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        maxWidth: "300px",
        height: "auto",
    },
    ticketIcon: {
        fontSize: "clamp(16rem, 25vw, 20rem)",
        color: "var(--color-background)",
        lineHeight: 1,
    },
    ticketIconDesktop: {
        fontSize: "clamp(18rem, 20rem, 14vh)",
    },
    ticketNumero: {
        position: "absolute",
        fontSize: "clamp(3.5rem, 10vw, 6rem)",
        fontWeight: "bold",
        color: "var(--color-text)",
    },
    ticketNumeroDesktop: {
        fontSize: "clamp(4rem, 6rem, 6vh)",
    },
};

function NumeroTicket({ numero }) {
    const isDesktop = window.innerWidth >= 992;
    const iconStyle = isDesktop ? { ...styles.ticketIcon, ...styles.ticketIconDesktop } : styles.ticketIcon;
    const numeroStyle = isDesktop ? { ...styles.ticketNumero, ...styles.ticketNumeroDesktop } : styles.ticketNumero;
    
    return (
        <div style={styles.ticket}>
            <i className="bi bi-ticket-fill" style={iconStyle}></i>
            <div style={numeroStyle}>{numero}</div>
        </div>
    );
}

export default NumeroTicket;
